'use client';

export function InactiveUserMessage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-8 max-w-md w-full text-center">
        <div className="mb-4">
          <svg
            className="mx-auto h-12 w-12 text-yellow-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-yellow-800 mb-2">
          等待管理员激活
        </h2>
        <p className="text-yellow-700 mb-4">
          您的账户已成功注册，但需要管理员激活后才能访问项目数据。
        </p>
        <p className="text-sm text-yellow-600">
          请耐心等待管理员审核并激活您的账户。激活后，您将能够正常使用系统。
        </p>
      </div>
    </div>
  );
}

